import { createFileRoute, useParams } from "@tanstack/react-router";
import { TemplateEditorContainer } from "../../../features/templates/containers/template-editor-container";

export const Route = createFileRoute("/app/template/$templateId")({
  component: () => <EditTemplateWrapper />,
});

function EditTemplateWrapper() {
  const { templateId } = useParams({ from: "/app/template/$templateId" });
  return <TemplateEditorContainer mode="edit" templateId={templateId} />;
}
